module.exports = {"updown_read_key":"ro-vkFfWq7feV3JvMTF842o","alias_includes":"Localizzer","twitter":"localizzer","website_name":"Localizzer","website_url":"https://localizzer.com","logo_url":"https://localizzer.com/assets/imgs/localizzer-theme-logo.png"}


//////////////////
// WEBPACK FOOTER
// ./page_config.json
// module id = Yr1l
// module chunks = 1